import { globalStyle, style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

const bubbleBase = {
  borderRadius: '14px',
  borderWidth: themeVars.border['width-0125'],
  borderStyle: 'solid',
  borderColor: themeVars.color['scope-neutral-subtle-border'],
  wordWrap: 'break-word',
  color: themeVars.color['text-primary'],
  maxWidth: '346px',
  width: '100%',
} as const;

// Ember's address table draws its own top rule, which divides the rows from the card's header.
export const addressInset = style(
  {
    borderBlockStart: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
  },
  'address-inset',
);

export const smsBubble = style(
  {
    ...bubbleBase,
    backgroundColor: themeVars.color['overlay-tint'],
  },
  'sms-bubble',
);

// Media in a Design Studio SMS arrives as full-size <img>; keep it inside the bubble.
globalStyle(`${smsBubble} img`, { width: '100%' });

export const smsBody = style(
  {
    whiteSpace: 'pre-wrap',
    padding: themeVars.space['125'],
  },
  'sms-body',
);

export const smsCardBody = style({ whiteSpace: 'pre-wrap' }, 'sms-card-body');

export const smsButton = style(
  {
    width: '100%',
    borderTopWidth: themeVars.border['width-0125'],
    borderTopStyle: 'solid',
    borderTopColor: themeVars.color['scope-neutral-subtle-border'],
    font: 'inherit',
    background: 'transparent',
    pointerEvents: 'none',
    paddingBlock: themeVars.space['100'],
    color: themeVars.color['scope-success-text'],
  },
  'sms-button',
);

export const whatsappBubble = style(
  {
    ...bubbleBase,
    backgroundColor: themeVars.color['surface-content'],
    paddingTop: themeVars.space['100'],
    display: 'flex',
    flexDirection: 'column',
  },
  'whatsapp-bubble',
);

export const whatsappText = style(
  {
    paddingBottom: themeVars.space['100'],
    paddingLeft: themeVars.space['125'],
    paddingRight: themeVars.space['125'],
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
  },
  'whatsapp-text',
);

export const whatsappButton = style(
  {
    width: '100%',
    borderTopWidth: themeVars.border['width-0125'],
    borderTopStyle: 'solid',
    borderTopColor: themeVars.color['scope-neutral-subtle-border'],
    font: 'inherit',
    background: 'transparent',
    pointerEvents: 'none',
    paddingBlock: themeVars.space['100'],
    color: themeVars.color['scope-action-text'],
  },
  'whatsapp-button',
);
